const MOD = 'CORE/SET/'
export const SADD = `${MOD}SADD`
export const SDEL = `${MOD}SDEL`
export const SREM = `${MOD}SREM`
export const SUNION = `${MOD}SUNION`
export const SDIFF = `${MOD}SDIFF`
export const SINTER = `${MOD}SINTER`
export const SMOVE = `${MOD}SMOVE`







// WEBPACK FOOTER //
// ./src/modules/set/actionTypes.js